import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import SectionTestimonials2 from "./section-testimonials2";

export function SectionWhyChooseUs2Inner() {
    return (
        <>
            <div className="row">
                <div className="col-lg-6 col-md-12">
                    <div className="sx-about-bx4-media">
                        <div className="sx-ab4-img-outer">
                            <div className="sx-ab4-media">
                                <ItodoImage src="images/about/p3.png" alt="media" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-12">
  <div className="sx-about-bx4-content">
    <h2 className="sx-title">Join Azown Technology – Innovate, Build, Grow</h2>

    <p>
      At Azown Technology, we specialize in delivering innovative digital solutions that empower
      businesses to grow and transform in a competitive world. Our team combines creativity,
      technology, and strategy to build scalable web and software solutions that create real
      business impact. Join us to work on meaningful projects, collaborate with skilled
      professionals, and grow your career with cutting-edge technologies.
    </p>

    <ul className="sx-arrow-circle-checked">
      <li>Innovative web and software development solutions</li>
      <li>Skilled and collaborative technology-driven team</li>
      <li>Growth-focused environment with continuous learning</li>
    </ul>

    <NavLink to="/services" className="site-button sx-btn-primary icon sx-btn-lg">
      <i className="fa fa-long-arrow-right" />
      View All Services
    </NavLink>
  </div>
</div>
            </div>
        </>
    )
}

function SectionWhyChooseUs2() {
    return (
        <>
            <div className="section-full  p-t110 p-b80 sx-bg-light sx-about-bx4-outer">
                <div className="container">
                    <div className="section-content">
                        <div className="sx-about-bx4-content-wrap p-b70">
                            <SectionWhyChooseUs2Inner />
                        </div>
                        {/*testimonial section */}
                        <SectionTestimonials2 />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionWhyChooseUs2;